import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue"
import { useRoute } from "vue-router"
import LoginLayout from "./layouts/login/LoginLayout.vue"
import MainLayout from "./layouts/main/MainLayout.vue"
import PublicLayout from "./layouts/public/PublicLayout.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()

const layouts = {
  main: MainLayout,
  login: LoginLayout,
  public: PublicLayout
}

const resolveLayout = computed(() => route.meta.requiresAuthorization ? layouts.main : route.meta.layout === "public" ? layouts.public : layouts.login)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(resolveLayout.value)))
}
}

})